// all lifeline endpoints to be moved here
export const lifelineEndPoints = {
  //   user level endpoints
  GET_LINKED_USER: 'user/linked_users',

  //   order level endpoints
  GET_TRANSACTION_DETAILS: `order/get_transactions_v2`,
  GET_PICKER_MEIDA: `order/get_picker_images`,
  GET_ORDER_OTP: `order/get_delivery_otp`,
  GET_CRYSTAL_VIEW: `order/crystal_view`,

  //   cart level endpoints
  GET_REFUNDS_IN_CART_DETAILS: `cart/get_refunds`,

  //   general endpoints
  GET_HELP_NODES_IN_LIFELINE: `helpdesk/fetch_help_nodes`,
  GET_CHAT_MEDIA: `chat_media/get_images`,
  GET_RIDER_IMAGES: `delivery_instructions/get_rider_images`,
  GET_ELIGIBLE_INSTRUCTIONS: `delivery_instructions/get_eligible_instructions`,
  POST_UPDATE_INSTRUCTIONS: `delivery_instructions/set_delivery_instructions`,
  POST_VALIDATE_TOTP_QR: `auth/validate_qr_code`,

  //logictics endpoints
  GET_ASSIGNMENT_HISTORY: `logistics/get_assignment_history`,
  GET_SECURE_RECORDING_URL: 'logistics/get_secured_recording_url',

  // OBD endpoints
  GET_TASKS: `external_apis/live_order_task/get_order_tasks`,
  UPDATE_TASK: `external_apis/live_order_task/update_order_task`,
  GET_LIVE_ORDER_CONFIG: 'issues/get_live_order_task_config',

  // Copilot endpoints
  GET_COPILOT_MENU: 'copilot/menu',
  CONFIRM_COPILOT_ITEMS: 'copilot/confirm_items',
  CONFIRM_COPILOT_COMPLAINT: 'copilot/confirm_complaint',
  SUBMIT_COPILOT_VERIFICATION: 'copilot/submit_verification',
  EVALUATE_COPILOT_RESOLUTION: 'copilot/evaluate',
  RECOMMENDED_COPILOT_RESPONSE: 'copilot/recommended_response',
  RESOLVE_COPILOT: 'copilot/resolve',
};
